export class Semaine {

  constructor(code, numero, coefAudience, coefTarif, codeMois, codeAudienceTarif) {
    this.code = code;
    this.numero = numero;
    this.coefAudience = coefAudience;
    this.coefTarif = coefTarif;
    this.codeMois = codeMois;
    this.codeAudienceTarif = codeAudienceTarif;
  }
}
